"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionInfo = exports.version = void 0;

/**
 * Note: This file is autogenerated using "resources/gen-version.js" script and
 * automatically updated by "yarn version" command.
 */

/**
 * A string containing the version of the GraphQL.js library
 */
var version = '14.7.0';
/**
 * An object containing the components of the GraphQL.js version string
 */

exports.version = version;
var versionInfo = Object.freeze({
  major: 14,
  minor: 7,
  patch: 0,
  preReleaseTag: null
});
exports.versionInfo = versionInfo;



//////////////////
// WEBPACK FOOTER
// ./~/graphql/version.js
// module id = 1362
// module chunks = 0